import { useState } from 'react'
import { Delete_SchoolGroup } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { mutate } from 'swr'
import { SchoolGroups_Listing, Single_SchoolGroup } from '@graphql/queries'
import { useCurrentUser } from '@hooks/useCurrentUser'

const useDeleteSchoolGroup = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { currentUser } = useCurrentUser()
  const { postMutation } = useApi()

  const post = async (id, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: { delete: id } },
      Delete_SchoolGroup,
      successMessage ? successMessage : 'Gruppen är raderad.',
      errorMessage ? errorMessage : 'Något gick fel när gruppen skulle raderas.',
      async () => {
        await mutate([SchoolGroups_Listing, currentUser.id])
        await mutate([Single_SchoolGroup, id])
      }
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useDeleteSchoolGroup }
